import React from "react";

import TitleBar from "../component/TitleBar";
import Header from "../common/Header";
import Footer from "../common/Footer";

import { ImStarEmpty, ImStarHalf, ImStarFull } from "react-icons/im";

function Partners() {

    return(
        <>
          <TitleBar title="Treatment" />
          <div className="header-in">
            <Header></Header>
          </div>

          <div className="treatment-wrap">
            <div className="container">
              <div className="sec-head"><span>London, United kingdom</span></div>
              <div className="text-block text-center pt-5 pb-5">
                <h2 className="title">Partners</h2>
                <p>Treatments are only performed by our own fully qualified nurses. Treatments can be given at the end of the initial consultation if agreed by the client. The <strong>home consultations</strong> is <strong>£150</strong>, and at the clinic is <strong>£49</strong>, but you can redeem it against any treatment purchase higher then <strong>249£</strong>. The payment for any home treatment it’s requested <strong>upfront</strong> and it’s <strong>non-renfundable</strong>, unless we fail to deliver the consulation in the specific day.</p>
                <p>Any purchase of treatments above <strong>249£</strong> comes <strong>with free consultation</strong>.</p>
              </div>

              <div className="">
                <div className="row">
                  <div className="col-sm-6 col-lg-4">
                        <div className="product-single partners-single">
                            <div className="product-thumb">
                              <img alt="" src={require('../images/partners/partner-1.png')} />
                            </div>
                            <h3>Erdem clinic</h3>
                            <h6>Instambul, Turkey</h6>
                            <div className="pro-bottom">
                              <div className="pro-bottom-left">
                                <div className="pro-ratings">
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span>4.5/5</span>
                                </div>
                                <a className="themeBtn" href="#">Visit Website</a>
                              </div>
                            </div>
                          </div>
                    </div>
                    <div className="col-sm-6 col-lg-4">
                        <div className="product-single partners-single">
                            <div className="product-thumb">
                              <img alt="" src={require('../images/partners/partner-2.png')} />
                            </div>
                            <h3>Clinicana</h3>
                            <h6>Instambul, Turkey</h6>
                            <div className="pro-bottom">
                              <div className="pro-bottom-left">
                                <div className="pro-ratings">
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span>4.5/5</span>
                                </div>
                                <a className="themeBtn" href="#">Visit Website</a>
                              </div>
                            </div>
                          </div>
                    </div>
                    <div className="col-sm-6 col-lg-4">
                        <div className="product-single partners-single">
                            <div className="product-thumb">
                              <img alt="" src={require('../images/partners/partner-3.png')} />
                            </div>
                            <h3>Medaway</h3>
                            <h6>Instambul, Turkey</h6>
                            <div className="pro-bottom">
                              <div className="pro-bottom-left">
                                <div className="pro-ratings">
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span>4.5/5</span>
                                </div>
                                <a className="themeBtn" href="#">Visit Website</a>
                              </div>
                            </div>
                          </div>
                    </div>
                    <div className="col-sm-6 col-lg-4">
                        <div className="product-single partners-single">
                            <div className="product-thumb">
                              <img alt="" src={require('../images/partners/partner-4.png')} />
                            </div>
                            <h3>Smile hair clinic</h3>
                            <h6>Instambul, Turkey</h6>
                            <div className="pro-bottom">
                              <div className="pro-bottom-left">
                                <div className="pro-ratings">
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span>4.5/5</span>
                                </div>
                                <a className="themeBtn" href="#">Visit Website</a>
                              </div>
                            </div>
                          </div>
                    </div>
                </div>
              </div>


              <div className="sec-head mt-5">Instanbul, turkey</div>
              <div className="text-block text-center pt-5 pb-5">
                <h2 className="title">Partners</h2>
                <p>Treatments are only performed by our own fully qualified nurses. Treatments can be given at the end of the initial consultation if agreed by the client. The <strong>home consultations</strong> is <strong>£150</strong>, and at the clinic is <strong>£49</strong>, but you can redeem it against any treatment purchase higher then <strong>249£</strong>. The payment for any home treatment it’s requested <strong>upfront</strong> and it’s <strong>non-renfundable</strong>, unless we fail to deliver the consulation in the specific day.</p>
                <p>Any purchase of treatments above <strong>249£</strong> comes <strong>with free consultation</strong>.</p>
              </div>

              <div className="">
              <div className="row">
                  <div className="col-sm-6 col-lg-4">
                        <div className="product-single partners-single">
                            <div className="product-thumb">
                              <img alt="" src={require('../images/partners/partner-1.png')} />
                            </div>
                            <h3>Erdem clinic</h3>
                            <h6>Instambul, Turkey</h6>
                            <div className="pro-bottom">
                              <div className="pro-bottom-left">
                                <div className="pro-ratings">
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span>4.5/5</span>
                                </div>
                                <a className="themeBtn" href="#">Visit Website</a>
                              </div>
                            </div>
                          </div>
                    </div>
                    <div className="col-sm-6 col-lg-4">
                        <div className="product-single partners-single">
                            <div className="product-thumb">
                              <img alt="" src={require('../images/partners/partner-2.png')} />
                            </div>
                            <h3>Clinicana</h3>
                            <h6>Instambul, Turkey</h6>
                            <div className="pro-bottom">
                              <div className="pro-bottom-left">
                                <div className="pro-ratings">
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span>4.5/5</span>
                                </div>
                                <a className="themeBtn" href="#">Visit Website</a>
                              </div>
                            </div>
                          </div>
                    </div>
                    <div className="col-sm-6 col-lg-4">
                        <div className="product-single partners-single">
                            <div className="product-thumb">
                              <img alt="" src={require('../images/partners/partner-3.png')} />
                            </div>
                            <h3>Medaway</h3>
                            <h6>Instambul, Turkey</h6>
                            <div className="pro-bottom">
                              <div className="pro-bottom-left">
                                <div className="pro-ratings">
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span>4.5/5</span>
                                </div>
                                <a className="themeBtn" href="#">Visit Website</a>
                              </div>
                            </div>
                          </div>
                    </div>
                    <div className="col-sm-6 col-lg-4">
                        <div className="product-single partners-single">
                            <div className="product-thumb">
                              <img alt="" src={require('../images/partners/partner-4.png')} />
                            </div>
                            <h3>Smile hair clinic</h3>
                            <h6>Instambul, Turkey</h6>
                            <div className="pro-bottom">
                              <div className="pro-bottom-left">
                                <div className="pro-ratings">
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span><ImStarFull/></span>
                                    <span>4.5/5</span>
                                </div>
                                <a className="themeBtn" href="#">Visit Website</a>
                              </div>
                            </div>
                          </div>
                    </div>
                </div>
              </div>

            </div>
          </div>

          <Footer></Footer>
        </>
    )
}

export default Partners;